import { Table, type TableProps } from 'antd';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useOrganizationsAndTutorsOfOrganizationOwner } from '../../hooks/useTutors';
import { useTranslation } from 'react-i18next';

interface DataType {
  key: React.Key;
  organizationName: string;
  tutorName: string;
}

export const TutorsOfOrganizationsTable = () => {
  const loggedInUser = useCurrentUser();
  const { t } = useTranslation();
  const { data: organizationsAndTutors } =
    useOrganizationsAndTutorsOfOrganizationOwner(loggedInUser.id);

  const data: DataType[] = [];

  organizationsAndTutors?.forEach((org) => {
    const tutors = org.tutorNames;
    const tutorCount = tutors.length;

    if (tutorCount === 0) {
      data.push({
        key: `${org.organizationName}-no-tutor`,
        organizationName: org.organizationName,
        tutorName: '',
      });
    } else {
      tutors.forEach((tutor, index) => {
        data.push({
          key: `${org.organizationName}-${tutor}-${index}`,
          organizationName: org.organizationName,
          tutorName: tutor,
        });
      });
    }
  });

  const columns: TableProps<DataType>['columns'] = [
    {
      title: t('tutorsOfOrganizationsTable.orgName'),
      dataIndex: 'organizationName',
      onCell: (record, index = 0) => {
        let rowSpan = 1;

        const currentOrg = record?.organizationName;

        // if the previous and next organization names is equals, do not merge the cells
        if (index === 0 || data[index - 1].organizationName !== currentOrg) {
          rowSpan = 0;
          for (let i = index; i < data.length; i++) {
            if (data[i].organizationName === currentOrg) {
              rowSpan++;
            } else {
              break;
            }
          }
        } else {
          rowSpan = 0;
        }

        return { rowSpan };
      },
    },
    {
      title: t('tutorsOfOrganizationsTable.tutorName'),
      dataIndex: 'tutorName',
    },
  ];

  return (
    <Table<DataType>
      columns={columns}
      dataSource={data}
      scroll={{ x: 'max-content' }}
      size="small"
      bordered
      pagination={{
        defaultPageSize: 15,
        position: ['bottomCenter'],
        showSizeChanger: true,
        pageSizeOptions: ['15', '30', '50', '100', '200'],
      }}
    />
  );
};
